const routeRoutes = {
  landing: {
    home: "/",
    languageAr: "/ar/",
    languageEn: "/en/",
    plans: "/plans",
    whyUs: "/why-us",
    blogs: "/blogs",
    blogDetails: "/blogs/:slug",
    contactUs: "/contact-us",
    plansAr: "/ar/خطط",
    whyUsAr: "/ar/منصة-محضر",
    contactUsAr: "/ar/اتصل-بنا",
  },
  home: "/dashboard",
  auth: {
    login: "/login",
    signUp: "/sign-up",
    resetPassword: "/reset-password",
    firstLogin: "/first-login",
    thankYou: "/thank-you",
  },
  errors: {
    forbidden: "/forbidden",
  },
  settings: {
    page: "/settings",
    rolesAndPermission: "/settings/roles",
  },

  company: {
    form: "/company/form",
  },
  users: {
    list: "/users",
    edit: "/users/form/:userId",
    add: "/users/form/new",
    profile: "/users/form/me",
  },
  workspaces: {
    list: "/workspaces",
    item: "/workspace/:workspaceId",
    createWorkspace: "/workspaces/form/new",
    edit: "/workspaces/edit/:workspaceId",
  },
  meetings: {
    add: "/meetings/form/new",
    edit: "/meetings/form/edit/:meetingId",
    item: "/meeting/:meetingId",
    liveItem: "/meeting/live/:meetingId",
    offline: "/meeting/offline/:meetingId",
    summaryItem: "/meeting/:meetingId/summary",
    archive: "/meetings/archive",
  },
  calendar: "/calendar",
  documents: "/documents",
  messages: "/messages",
  votings: {
    add: "/votings/form/add",
    item: "/voting/:votingId",
    list: "/votings",
    edit: "/votings/form/edit/:votingId",
    liveItem: "/voting/live/:votingId",
    offlineItem: "/voting/offline/:votingId",
    summaryItem: "/voting/:votingId/summary",
  },
  tasks: {
    list: "/tasks",
    item: "/task/:taskId",
    globalItem: "/task/global/:taskId",
    add: "/tasks/form/new",
    edit: "/tasks/edit/:taskId",
  },
  ui: {
    meetings: {
      list: "/ui/meeting",
      item: "/ui/meeting/:meetingId",
      detail: "/ui/meeting/details/:meetingId",
      itemSummary: "/ui/meeting/:meetingId/summary",
      summary: "/ui/meeting/summary/:meetingId",
      meetingMinutes: "/ui/meeting-minutes",
      liveItem: "/ui/meeting/live/:meetingId",
      liveItemPublic: "/ui/meeting/live/guest/:meetingId",
    },
    videoRecord: {
      show: "/ui/video-record",
    },
    settings: {
      show: "/ui/settings",
    },
    workspace: {
      details: "/ui/workspace/:workspaceId",
    },
  },
  admin: {
    users: {
      list: "/admin/users",
    },
  },
  contentPages: {
    terms: "/term-of-use",
    privacy: "/privacy-policy",
  },
};

export const routeMap: Record<string, string> = {
  "/plans": "/ar/خطط",
  "/why-us": "/ar/منصة-محضر",
  "/contact-us": "/ar/اتصل-بنا",

  "/ar/خطط": "/plans",
  "/ar/منصة-محضر": "/why-us",
  "/ar/اتصل-بنا": "/contact-us",

  "/ar/": "/",
  "/en/": "/",
};

export default routeRoutes;
